/**
 * Where "Raise credit note" from a client invoice goes: a new note, pre-filled from it
 * (item 14, 9 Oct 2026 QA retest). Was a bare `/credit-notes/new` with nothing carried over,
 * so the form opened blank and the clerk re-typed the client, vessel, currency and re-found the
 * invoice by hand. Mirrors `quantityCorrection.newVendorReturnPath` — the same shape this app
 * already uses for "open a form pre-filled from a navigation" (a vendor return from a vendor
 * invoice) — rather than inventing a second mechanism (query param, not router state, so the
 * link survives a copy/paste or a reload).
 */
export function newCreditNotePath(clientInvoiceId: string): string {
  return `/credit-notes/new?clientInvoiceId=${encodeURIComponent(String(clientInvoiceId))}`;
}
